export default __webpack_public_path__ + "static/北京金融产业联盟-聂丽琴-1922deb5eb532392172bd7ffc1e38ba4.png";